import { CompanyTestType } from "global-query-types";

export const nomineeCompanyTestType = [
  CompanyTestType.Employees,
  CompanyTestType.Shelf,
  CompanyTestType.Test
];
